import axios from 'axios';
import localStore from 'store';
import AuthProvider from './auth';
import router from '../router';
import { EventBus } from './event-bus';

const API_URL = process.env.VUE_APP_API;

const authService = new AuthProvider();

axios.interceptors.response.use((response) => {
  // Get response
  // If response is error, get permissions
  // in router: if permission is denied router can show
  // 'no permission' module instead of what would be there
  // If logged out log out

  /* Check if logged in, if not, clear storage and redirect to login page */
  if (response.data.error === true) {
    if (response.data.message === 'You must login to access this endpoint') {
      localStore.clearAll();
      router.push('/login');
      return false;
    }
  }
  return response;
}, (error) => {
  let errorMessage = error.message;
  try {
    if (error.response.data.message) {
      errorMessage = error.response.data.message;
    }
  } catch (e) {} //eslint-disable-line
  EventBus.$emit('renderGlobalMessage', ({ message: errorMessage, icon: 'exclamation-circle', type: 'error' }));

  return Promise.reject(error);
});

const HTTP = options => axios({
  method: options.method || 'get',
  url: `${API_URL}/${options.url}`,
  params: options.params,
  headers: {
    Authorization: `Bearer ${authService.getToken()}`,
  },
  data: options.data,
  onUploadProgress: options.progressEvent,
});

export default HTTP;
